import { useMutation } from "@apollo/client";
import { AddAndRemoveOrgTagsMutationInput } from "@clockwise/schema";
import { isEmpty } from "lodash";
import { AddAndRemoveOrgTagsDocument } from "../mutations/__generated__/AddAndRemoveOrgTags.generated";
import { AddOrgTagsDocument } from "../mutations/__generated__/AddOrgTags.generated";
import { RemoveOrgTagsDocument } from "../mutations/__generated__/RemoveOrgTags.generated";

// pick which mutation to use based on the inputs
const useAddRemoveOrgTags = () => {
  const [addAndRemove] = useMutation(AddAndRemoveOrgTagsDocument);
  const [removeOrgTags] = useMutation(RemoveOrgTagsDocument);
  const [addOrgTags] = useMutation(AddOrgTagsDocument);

  const addAndRemoveOrgTags = (
    input: AddAndRemoveOrgTagsMutationInput,
    onSuccess: (response?: any) => void,
    onError: (error?: any) => void,
  ) => {
    const needsAdd = !isEmpty(input.tagsToAdd);
    const needsRemove = !isEmpty(input.tagNamesToRemove);

    if (needsAdd && needsRemove) {
      addAndRemove({
        variables: {
          input,
        },
        onCompleted: onSuccess,
        onError,
      });
    } else if (needsRemove) {
      removeOrgTags({
        variables: {
          input: {
            orgRelayId: input.orgRelayId,
            eventParentRelayId: input.eventParentRelayId,
            tagNames: input.tagNamesToRemove,
          },
        },
        onCompleted: onSuccess,
        onError,
      });
    } else if (needsAdd) {
      addOrgTags({
        variables: {
          input: {
            orgRelayId: input.orgRelayId,
            eventParentRelayId: input.eventParentRelayId,
            tags: input.tagsToAdd,
            moveRangeV3: input.moveRangeV3,
            calendarId: input.calendarId,
          },
        },
        onCompleted: onSuccess,
        onError,
      });
    }
  };

  return [addAndRemoveOrgTags];
};

export default useAddRemoveOrgTags;
